import { createTheme, ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { HashRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Routes from './routes';


const mdTheme = createTheme({
	palette: {
		tertiary: {
			main: '#23c6c8',
			dark: '#1b9d9e'
		}
	},
	components: {
		MuiInputLabel: {
			variants: [
				{
					props: { variant: 'form' },
					style: {
						transform: 'translate(2px, 5px) scale(1)'
					}
				}
			]
		},
		MuiCheckbox: {
			variants: [
				{
					props: { variant: 'form' },
					style: {
						padding: '4px'
					}
				}
			]
		},
		MuiCard: {
			variants: [
				{
					props: { variant: 'hover-shadow' },
					style: {
						'&:hover': {
							boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.75)',
							transition: 'all 0.3s ease-in-out'
						}
					}
				}
			]
		},
		MuiCssBaseline: {
			styleOverrides: {
				'*::-webkit-scrollbar': {
					width: '0.4em'
				},
				'*::-webkit-scrollbar-track': {
					'-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
				},
				'*::-webkit-scrollbar-thumb': {
					backgroundColor: 'rgba(0,0,0,.1)',
					outline: '1px solid slategrey'
				}
			}
		},
		MuiDataGrid: {
			styleOverrides: {
				root: {
					'& .MuiFormControl-root': {
						'& .MuiInputBase-root': {
							'& .MuiInputBase-input': {
								height: '33px'
							}
						}
					},
					'& .MuiAutocomplete-root': {
						'& .MuiFormControl-root': {
							'& .MuiAutocomplete-input': {
								height: '25px'
							}
						}
					}
				}
			}
		}
	},
	mixins: {
		drawer: {
			width: 320
		}
	},
	zIndex: {
		appBar: 1301,
		drawer: 1100,
		autoCompletePopper: 1300,
		dataGridMenu: 1150,
		dataGridPanel: 1150,
		modal: 1200
	}
});
const AppRoot = () => {

	return (
		<ThemeProvider theme={mdTheme}>
				<HashRouter>
					<Routes />
				</HashRouter>
			<ToastContainer />
		</ThemeProvider>
	);
};
export default AppRoot;